import { connect } from 'react-redux';
import withImmutablePropsToJS from 'with-immutable-props-to-js';

import { Instances } from '../../../../constants';
import { IStateType } from '../../../../store/models/root.interface';

import {
	makeSelectError,
	makeSelectInProgress,
	makeSelectObjectsArray,
	updateObjects,
} from '../../../../store/Objects';
import ApiKeysCreateForm, { DispatchPropsType, MapStateType } from '../organisms/APIKeyCreate/ApiKeysCreateForm';


const mapStateToProps = (state: IStateType) => ({
	apiKeyData: makeSelectObjectsArray(Instances.apiKeys)(state) || [],
	apiKeyError: makeSelectError(Instances.apiKeys)(state),
	apiKeyLoading: makeSelectInProgress(Instances.apiKeys)(state),
});

const mapDispatchToProps = {
	onSaveKey: (data: any, callBack: any) =>
		updateObjects(
			Instances.apiKeys,
			'POST',
			data,
			{},
			undefined,
			'id',
			undefined,
			undefined,
			callBack
		),
};

export default connect<MapStateType, DispatchPropsType, unknown, IStateType>(
	mapStateToProps,
	mapDispatchToProps
)(withImmutablePropsToJS(ApiKeysCreateForm));
